import { Contacts } from "../Components/education/Contacts/Contacts.jsx"
import { Dashboard } from "../Components/dashboard/Dashboard"
import { Enquiry } from "../Components/education/Enquiry"
import { Master } from "../Components/masters/Masters/Master"
import { Route, Routes, useLocation } from "react-router-dom"
import { Department } from "../Components/masters/Department/Department"
import { Designation } from "../Components/masters/Designation/Designation"
import { Users } from "../Components/users/Users"
import { Settings } from "../pages/Settings"
import { RoleManagement } from "../Components/masters/RoleManagement"
import { CreateShift } from "../Components/masters/shift/CreateShift"
import { LeadSoucre } from "../Components/masters/leadSource/LeadSource"
import { ErrorPage } from "../Components/ErrorPage"
import { Protected } from "../Protected"
import { Companies } from "../Components/education/Companies"
import { ChangePassword } from "../Components/changePassword/ChangePassword"
import useLocalStorageState from "use-local-storage-state"
import { ProductServices } from "../Components/masters/productService/ProductServices"
import { useEffect } from "react"
import { CreatePipelinePage } from "../Components/PipelineComponents/CreatePipelinePage"
import { EditPipelinePage } from "../Components/PipelineComponents/EditPipelinePage"
import { Preferences } from "./../Components/masters/Preferences/Preferences"
import { NotificationTemplates } from "./../Components/masters/Preferences/NotificationTemplates"
import { Integrations } from "./../Components/masters/Integrations/Integrations"
import { MSG } from "../Components/masters/Integrations/MSG"
import { EmailIntegration } from "../Components/masters/Integrations/EmailIntegrations"
import CustomFieldManager from "./../Components/CustomFields/components/CustomFieldManager"
import { EmailCampaingning } from "../Components/campaigningComponents/EmailCampaingning"
import { Deals } from "../Components/deals/Deals"
import { WhatsAppCampainging } from "../Components/campaigningComponents/WhatsAppCampainging"
import { AddCurrency } from "../Components/masters/Currency/Currency"
import { CreateQuotation } from "./../Components/Quotation/CreateQuotation"
import { Quotations } from "./../Components/Quotation/Quotations"
import Prefix from "../Components/masters/Preferences/Prefix"
import { DetailsQuotation } from "../Components/Quotation/DetailsQuotation"
import { PurchaseOrder } from "./../Components/PurchaseOrder/PurchaseOrder"
import { CreatePurchaseOrder } from "./../Components/PurchaseOrder/CreatePurchaseOrder"
import { CreateSalesOrder } from "../Components/SalesOrder/CreateSalesOrder"
import { PurchaseDetail } from "../Components/PurchaseOrder/PurchaseDetail"
// import { SalesOrder } from './../Components/SalesOrder/SalesOrder';
import TabIndex from "../Components/SalesOrder/TabIndex"
import { CreateInvoiceOrder } from "./../Components/Invoice/CreateInvoiceOrder"
import { CreateRecurringOrder } from "./../Components/RecurringInvoices/CreateRecurringOrder"
import { Templates } from "./../Components/masters/templates/Templates"
import { Chart } from "./../Components/masters/charts/Chart"
import { CreatePayment } from "./../Components/payment/CreatePayment"
import { GoogleCalendar } from "../Components/Calendar/GoogleCalender"
import Projects from "./../Components/project/Project"
import { Report } from "./../Components/report/Report"
import { QuotationDetails } from "./../Components/Quotation/QuotationDetails"
import { EditQuotation } from "../Components/Quotation/EditQuation"
import { ProjectDashboard } from "../Components/dashboard/ProjectDashboard"
import EmailSettings from "../Components/dashboard/inbox/EmailSettings"
import EmailSmtpIntegration from "../Components/dashboard/inbox/EmailSmtpIntegration"
import { EditInvoice } from "../Components/Invoice/EditInvoice"
import SMSTemplate from "../Components/masters/Preferences/SMSTemplate"
import Announcement from "../Components/masters/Preferences/Announcement"
import KnowledgeBase from "../Components/masters/Preferences/KnowledgeBase"
import LeadsVisibility from "../Components/masters/Preferences/LeadsVisibility"
import SetTarget from "../Components/masters/Preferences/SetTarget"
import WhatsappAPI from "../Components/masters/Preferences/WhatsappAPI"
import TermsAndConditions from "../Components/masters/Preferences/TermsAndConditions"
import Tools from "../Components/tools/Tools"
import SMSCampaigning from "../Components/campaigningComponents/SMSCampaigning"
import { Subscription } from "../pages/Subscription"
import { Summary } from "../pages/Summary"
import { RolePermission } from "../pages/RolePermission"
import WorkFlowTable from "../Components/WorkFlow/WorkFlowTable"
import WorkFlow from "../Components/WorkFlow/WorkFlow"
import { Setup } from './../Profile/Setup';
import { SetupCompanyDetails } from './../Profile/SetupCompanyDetails';
import { SetupGst } from './../Profile/SetupGst';
import { SetupUserDetails } from './../Profile/SetupUserDetails';
import PaymentDetails from './../Components/subscriptionPayment/PaymentDetails';
import SubscriptionDetails from './../Components/subscriptionPayment/SubscriptionDetails';
import { EditSalesOrder } from "../Components/SalesOrder/EditSalesOrder"
import { ImportData } from './../pages/Import/ImportData';
import BrowserCall from './../Components/ivr/BrowserCall';
//@ts-ignore
import Leads from "../Components/Leads/Leads.jsx"
import EmailContainer from './../Components/dashboard/inbox/EmailContainer';
import { IntegrationDetail } from './../Components/masters/Integrations/IntegrationDetail';
import RoundRobin from './../Components/RoundRobin/RoundRobin';


export const Routers = () => {
  const location = useLocation()
  const [, setLastPath] = useLocalStorageState("lastPath", "/dashboard")

  // Define paths that should NOT save the lastPath
  const excludedPaths = ["/login", "/register", "/", "/forgot-password"]
  const isCreatePasswordRoute =
    location.pathname.startsWith("/create-password/")

  useEffect(() => {
    // Only save the path if it's not in excluded paths and not a create-password route
    if (!excludedPaths.includes(location.pathname) && !isCreatePasswordRoute) {
      setLastPath(location.pathname)
    }
  }, [location.pathname, setLastPath])
  return (
    <>
      <Routes>
        <Route path="/planSummary" element={<Summary />}></Route>
        <Route element={<Protected />}>
          <Route path="/dashboard" element={<Dashboard />}></Route>
          <Route path="/enquiry" element={<Enquiry />}></Route>
          <Route path="/contacts" element={<Contacts />}></Route>
          <Route path="/deals" element={<Deals />}></Route>
          <Route path="/master" element={<Master />}></Route>
          <Route path="/company" element={<Companies></Companies>} />
          <Route path="/quotations" element={<Quotations></Quotations>} />
          <Route path="/workflow" element={<WorkFlowTable></WorkFlowTable>} />
          <Route path="/createworkflow" element={<WorkFlow></WorkFlow>} />
          <Route path="/editworkflow/:paramId" element={<WorkFlow></WorkFlow>} />
          <Route path="/rolePermissions" element={<RolePermission />}></Route>
          <Route path="/paymentdetails" element={<PaymentDetails />}></Route>
          <Route path="/subscriptiondetails" element={<SubscriptionDetails />}></Route>
          <Route path="/editsalesorder/:paramId" element={<EditSalesOrder />}></Route>
          <Route path="/integration/twillo" element={<BrowserCall />} />
          <Route path="/roundrobin" element={<RoundRobin />} />
          <Route path="/setup" element={<Setup />}>
            <Route path="companyDetails" index element={<SetupCompanyDetails />} ></Route>
            <Route path="gst" index element={<SetupGst />} ></Route>
            <Route path="userDetails" index element={<SetupUserDetails />} ></Route>
          </Route>
          <Route path='/email-settings' element={<EmailSettings />}></Route>
          <Route path='/importdata' element={<ImportData />}></Route>
          <Route path='testing' element={<EmailContainer />}></Route>
          <Route
            path="/createquotation"
            element={<CreateQuotation></CreateQuotation>}
          />
          <Route
            path="/detailquotation/:paramId"
            element={<DetailsQuotation />}
          />
          <Route path="/editquotation/:paramId" element={<EditQuotation />} />
          <Route
            path="/quotationdetail/:quoteID/:customerId/:quotationNumber"
            element={<QuotationDetails />}
          ></Route>
          <Route
            path="/purchaseorder"
            element={<PurchaseOrder></PurchaseOrder>}
          />
          <Route
            path="/createpurchaseorder/:id"
            element={<CreatePurchaseOrder></CreatePurchaseOrder>}
          />
          <Route path="/calender" element={<GoogleCalendar />} />
          <Route path="/projects" element={<Projects />} />
          <Route path="/reports" element={<Report />} />
          {/* <Route path='/salesorder' element={<SalesOrder></SalesOrder>} /> */}
          <Route path="/salesorder" element={<TabIndex />} />
          <Route
            path="/createSalesOrder"
            element={<CreateSalesOrder></CreateSalesOrder>}
          />
          <Route
            path="/purchaseDetail/:id/:module"
            element={<PurchaseDetail />}
          />
          <Route path="/templates" element={<Templates />} />
          <Route path="/chartOfAccounts" element={<Chart />} />
          {/* {invoice order } */}
          <Route path="/createInvoiceOrder" element={<CreateInvoiceOrder />} />
          <Route path="/cloneInvoice/:cloneId" element={<EditInvoice />} />
          <Route path="/createpayment" element={<CreatePayment />} />
          {/* {recurring invoice} */}
          <Route
            path="/createRecurringOrder"
            element={<CreateRecurringOrder />}
          />
          <Route path="/settings" element={<Settings />}>
            <Route path="masters" element={<Master />} />
            <Route path="integration/:id" element={<IntegrationDetail />} />
            <Route path="users" element={<Users />}></Route>
            <Route path="roleManagement" element={<RoleManagement />} />
            <Route path="preference" element={<Preferences />} />

            <Route path="integration" element={<Integrations />} />
          </Route>
          <Route path="/leads" element={<Leads />}></Route>
          <Route
            path="/createpipeline"
            element={<CreatePipelinePage />}
          ></Route>
          <Route
            path="/editpipeline/:encodedId"
            element={<EditPipelinePage />}
          ></Route>
          <Route path="/integration/msg91" element={<MSG />} />
          <Route path="/integration/email" element={<EmailIntegration />} />
          {/* MASTERS */}
          <Route path="/department" element={<Department />} />
          <Route path="/product" element={<ProductServices />} />
          <Route path="/designation" element={<Designation />} />
          <Route path="/shift" element={<CreateShift />} />
          <Route path="/currency" element={<AddCurrency />} />
          <Route path="/enquirySource" element={<LeadSoucre />} />
          <Route path="/changePassword" element={<ChangePassword />} />
          {/* preference */}
          <Route path="/preferences/form" element={<CustomFieldManager />} />
          <Route
            path="/preferences/notificationTemplates"
            element={<NotificationTemplates />}
          />
          <Route path="/preferences/sms-templates" element={<SMSTemplate />} />
          <Route path="/preferences/announcement" element={<Announcement />} />
          <Route
            path="/preferences/knowledge-base"
            element={<KnowledgeBase />}
          />
          <Route
            path="/preferences/leads-visibility"
            element={<LeadsVisibility />}
          />
          <Route path="/preferences/set-target" element={<SetTarget />} />
          <Route path="/preferences/whatsapp-api" element={<WhatsappAPI />} />
          <Route
            path="/preferences/terms-conditions"
            element={<TermsAndConditions />}
          />

          <Route path="/preferences/prefix" element={<Prefix />} />
          <Route path="/email" element={<EmailCampaingning />} />
          <Route path="/whatsapp" element={<WhatsAppCampainging />} />
          <Route
            path="/ProjectDashboard"
            element={<ProjectDashboard />}
          ></Route>
          {/* <Route path="/email-settings" element={<EmailSettings />}></Route> */}
          <Route path="/testing" element={<EmailSmtpIntegration />}></Route>
          <Route path="/tools" element={<Tools />}></Route>
          <Route path="/sms" element={<SMSCampaigning />}></Route>

          {/* <Route path='/crm/leads' element={<Leads />}></Route> */}
        </Route>
        <Route path="/plans" element={<Subscription />}></Route>
        {/* s✅ Default route */}
        {/* {<Route path="*" element={<ErrorPage />} /> } */}
      </Routes>
    </>
  )
}
